import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ColorService {

  constructor() { }
  getRandomColor() {
    let letters = '0123456789ABCDEF';
    let color = '#';
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }

    return color;
  }

  checkedColor(arrayColorUsed) {
    let color = this.getRandomColor();

    if (arrayColorUsed.includes(color)) {
      this.checkedColor(arrayColorUsed);
    }

    return color;


  }
}
